import { useMemo } from 'react'
import Select from 'react-select'
import Typeahead from '../helpers/Typeahead'
import { defineMessages, FormattedMessage, useIntl } from 'react-intl'
import { autosuggestStyles } from '../search/helpers'
import { TrustPilotBlock, FilterList } from '../search/'
// import TravelDatepicker from '../helpers/TravelDatepicker'

const expandedFilters = {
  trip_type: true,
  trip_language: true,
}

const message = defineMessages({
  placeholder: {
    id: 'homepage.search.placeholder',
    defaultMessage: 'Where do you want to go?',
  },
})

export default function FiltersGroup({
  model,
  pk,
  monthes,
  updateParams,
  title,
  selectedFilters,
  isWidget,
  triggerApi,
  clearDates,
  items,
  clearSelectedFilters,
  trustpilotLocale,
  filtersCount,
}) {
  const intl = useIntl()
  const updateMonth = (selectedOption) => {
    if(!selectedOption) {
      clearDates()
    } else {
      updateParams({
        departure_date_month: selectedOption,
        departure_date: selectedOption.from,
      })
    }
  }
  const apiUrl = useMemo(
    () => `search/${model.toLowerCase()}/${pk}/organisers/`,
    [model, pk],
  )

  return (
    <div className='filters'>
      <div className='main-filters' id='la-main-filters'>
        <p className='title'>
          <FormattedMessage id='search' defaultMessage='Search' />
        </p>
        <div className='search-block'>
          <label className='w_icon'>
            <i className='font-icons field-icon location-icon' />
            <Typeahead
              onFocusClear
              isWidget={isWidget}
              type='group'
              placeholder={intl.formatMessage(message.placeholder)}
              inputValue={title}
              popupId='country-list-popup'
              setLoading={() => {}}
            />
          </label>
        </div>
        <div
          className={`form-group w_icon ${
            !selectedFilters.departure_date_month ? 'has-error' : ''
          }`}
        >
          <i className='font-icons field-icon calendar-icon' />
          <Select
            onChange={updateMonth}
            value={selectedFilters.departure_date_month}
            options={monthes}
            styles={autosuggestStyles}
            isSearchable={false}
            valueKey='id'
            isClearable
            className='select-container'
            classNamePrefix='select-container'
          />
        </div>
        <button className='btn-red' id='search-btn' onClick={triggerApi}>
          <i className='font-icons find-icon' />
          <FormattedMessage id='search' defaultMessage='Search' />
        </button>
      </div>
      <FilterList
        expandedFilters={expandedFilters}
        updateParams={updateParams}
        selectedFilters={selectedFilters}
        items={items}
        showTripOrganiser
        clearSelectedFilters={clearSelectedFilters}
        filtersCount={filtersCount}
        groupTrips
        url={apiUrl}
        organiserPlaceholder='name_or_location'
        label={
          <FormattedMessage
            id='tripOrganiser'
            defaultMessage='Trip organisers'
          />
        }
      />
      <TrustPilotBlock trustpilotLocale={trustpilotLocale} />
    </div>
  )
}
